import type { SmartCalcColumnId as ColumnId } from '../calcStack';
import type { RowValidationField } from '../types/validation';
import { COL } from './columnIds';

/**
 * Maps each RowValidationField to its calculator ColumnId.
 * `undefined` means the field has no matching column (e.g. startDate / endDate
 * are row-level fields with no column to surface validation against).
 * Adding a new RowValidationField forces the maintainer to assign a column id
 * (or `undefined` deliberately) — TS errors on missing keys.
 */
const FIELD_TO_COLUMN_ID: Readonly<Record<RowValidationField, ColumnId | undefined>> = {
  price: COL.price,
  dailyBudget: COL.dailyBudget,
  overallBudget: COL.overallBudget,
  dailyTraffic: COL.dailyTraffic,
  overallTraffic: COL.overallTraffic,
  startDate: undefined,
  endDate: undefined,
  cappingImpressions: COL.capping,
  cappingFrequency: COL.capping,
};

export const fieldToColumnId = (field: RowValidationField): ColumnId | undefined => FIELD_TO_COLUMN_ID[field];
